module.exports = __webpack_public_path__ + "static/media/boy-15.652a5797.svg";